module.exports = __webpack_public_path__ + "img/font_tahoma_1.614a369e.svg";